<template>
  <v-dialog v-model="show" max-width="900" persistent>
    <v-card>
      <v-card-title class="grey lighten-3">
        <v-row align="center">
          <v-icon class="draggable">mdi-drag</v-icon>
          <v-col class="py-0"> {{ title }} </v-col>
          <v-col class="py-0">
            <v-container py-0
              ><v-row justify="end">
                <v-btn icon color="indigo" @click="$emit('close')">
                  <v-icon>mdi-close</v-icon>
                </v-btn></v-row
              ></v-container
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <rate-type-list-select
              v-model="rateTypeCode"
              @onSelect="onRateTypeSelect"
              :outlined="outlinedInputs"
              hideNotInUse
            ></rate-type-list-select>
          </v-col>
        </v-row>
        <h5 class="title">Buy</h5>
        <v-row>
          <v-col>
            <v-text-field
              :disabled="isPerPerson"
              name="Item Buy"
              label="Item"
              type="number"
              v-model.number="itemBuy"
              @change="onChangeListener($event)"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :disabled="!isPerPerson"
              name="Adult Buy"
              type="number"
              label="Adult"
              v-model.number="adultBuy"
              @change="onChangeListener($event)"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :disabled="!isPerPerson"
              name="Child Buy"
              type="number"
              label="Child"
              v-model.number="childBuy"
              @change="onChangeListener($event)"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :disabled="!isPerPerson"
              name="Infant Buy"
              type="number"
              label="Infant"
              v-model.number="infantBuy"
              @change="onChangeListener($event)"
            ></v-text-field>
          </v-col>
          <v-col>
            <currency-list-select
              :include-exchange-rate="true"
              v-model="currencyBuy"
            ></currency-list-select>
          </v-col>
        </v-row>
        <h5 class="title">Sell</h5>
        <v-row>
          <v-col>
            <v-text-field
              :disabled="isPerPerson"
              name="Item Sell"
              label="Item"
              type="number"
              v-model.number="itemSell"
              @change="onChangeListener($event)"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :disabled="!isPerPerson"
              name="Adult Sell"
              type="number"
              label="Adult"
              v-model.number="adultSell"
              @change="onChangeListener($event)"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :disabled="!isPerPerson"
              name="Child Sell"
              type="number"
              label="Child"
              v-model.number="childSell"
              @change="onChangeListener($event)"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :disabled="!isPerPerson"
              name="Infant Sell"
              type="number"
              label="Infant"
              v-model.number="infantSell"
              @change="onChangeListener($event)"
            ></v-text-field>
          </v-col>
          <v-col>
            <currency-list-select
              :include-exchange-rate="true"
              v-model="currencySell"
            ></currency-list-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox
              label="Custom Price"
              v-model="customPricing"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              label="Include Markup"
              v-model="includeMarkup"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="debug">
          <v-col
            >[{{ value }}]
            {{ supplier }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="grey lighten-4">
        <v-spacer></v-spacer>

        <v-btn color="warning" text @click="$emit('close')">Cancel</v-btn>
        <v-btn color="primary" :disabled="!isValid" @click="onSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RateTypeListSelect from "../../shared/RateTypeListSelect";
import CurrencyListSelect from "../../shared/CurrencyListSelect";
import gql from "graphql-tag";
const SUPPLIER_INFO = gql`
  query supplierInfo($id: ID!) {
    supplier(id: $id) {
      currencyCode
      currencyExchangeRate
      defaultRateTypeCode
    }
  }
`;
export default {
  name: "template-builder-pricing-dialog",
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    RateTypeListSelect,
    CurrencyListSelect,
  },
  data() {
    return {
      debug: false,
      rateTypeCode:
        this.value && this.value.rateTypeCode ? this.value.rateTypeCode : "",
      rateType: null,
      itemBuy: this.value ? this.value.itemBuy : 0,
      adultBuy: this.value ? this.value.adultBuy : 0,
      childBuy: this.value ? this.value.childBuy : 0,
      infantBuy: this.value ? this.value.infantBuy : 0,
      itemSell: this.value ? this.value.itemSell : 0,
      adultSell: this.value ? this.value.adultSell : 0,
      childSell: this.value ? this.value.childSell : 0,
      infantSell: this.value ? this.value.infantSell : 0,
      currencyBuy:
        this.value && this.value.currencyBuy ? this.value.currencyBuy : "",
      currencySell:
        this.value && this.value.currencySell ? this.value.currencySell : "",
      currencyBuyExRate: 1,
      currencySellExRate: 1,
      customPricing: this.value ? this.value.customPricing : false,
      includeMarkup: this.value ? this.value.includeMarkup : false,
      duration: this.value ? this.value.duration : 1,
    };
  },
  watch: {
    value(newVal) {
      for (let key in newVal) {
        if (this.hasOwnProperty(key)) {
          if (
            ["currencyBuy", "currencySell", "rateTypeCode"].indexOf(key) != -1
          ) {
            if (newVal[key] && newVal[key] != "") {
              this[key] = newVal[key];
            }
          } else {
            this[key] = newVal[key];
          }
        }
      }
    },
  },

  computed: {
    title() {
      return this.value && this.value.id
        ? `${this.value.supplierName} - ${this.value.serviceName}`
        : "Pricing";
    },
    isValid() {
      return (
        this.rateTypeCode &&
        this.rateTypeCode != "" &&
        this.currencySell &&
        this.currencySell != "" &&
        this.currencyBuy &&
        this.currencyBuy != ""
      );
    },
    supplierId() {
      return this.value && this.value.supplierId.toString() != ""
        ? this.value.supplierId
        : "";
    },
    isPerPerson() {
      return this.rateType ? this.rateType.includePax : false;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },
  methods: {
    onSave() {
      const input = {
        ...this.value,
        rateTypeCode: this.rateTypeCode,
        itemBuy: this.itemBuy,
        adultBuy: this.adultBuy,
        childBuy: this.childBuy,
        infantBuy: this.infantBuy,
        itemSell: this.itemSell,
        adultSell: this.adultSell,
        childSell: this.childSell,
        infantSell: this.infantSell,
        currencyBuy: this.currencyBuy,
        currencySell: this.currencySell,
        customPricing: this.customPricing,
        includeMarkup: this.includeMarkup,
      };
      this.$emit("input", input);
      this.$emit("save", input);
    },
    onRateTypeSelect(rateType) {
      this.rateType = { ...rateType };
    },
    onChangeListener() {
      //console.log("price changed");
      this.customPricing = true;
      this.includeMarkup = true;
    },
    onBuyCurrencySelect(payload) {
      //console.log("buy currency changed", payload);
    },
    onSellCurrencySelect(payload) {
      //console.log("sell currency changed", payload);
    },
    // getTotalFunction(type) {
    //   const totalFunction = () => {
    //     let total = 0;

    //     if (this.isPerPerson) {
    //       total =
    //         Number(this[`adult${type}`]) +
    //         Number(this[`child${type}`]) +
    //         Number(this[`infant${type}`]);
    //     } else {
    //       total = Number(this[`item${type}`]);
    //     }
    //     if (this.rateType && this.rateType.includeDays) {
    //       total = total * this.duration;
    //     }

    //     return total;
    //   };
    //   return totalFunction;
    // }
  },
  apollo: {
    supplier: {
      query: SUPPLIER_INFO,
      variables() {
        return { id: this.supplierId };
      },
      skip() {
        return this.supplierId == "";
      },
      result({ data }) {
        if (!this.currencyBuy || this.currencyBuy == "") {
          this.currencyBuy = data.supplier.currencyCode;
          this.currencySell = data.supplier.currencyCode;
          this.currencyBuyExRate = data.supplier.currencyExchangeRate;
        }
        if (this.rateTypeCode || this.rateTypeCode == "") {
          this.rateTypeCode = data.supplier.defaultRateTypeCode;
        }
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/TemplateBuilderItemPricingDialog.vue